import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { transactionsService } from '../services/transactionService'
import { useToast } from '../../view/components/ui/use-toast'
import { TransactionChartParams } from '../services/transactionService/transactionChart'
import { useEffect, useState } from 'react'
import { startOfDay, subDays } from 'date-fns'

interface useTransactionChartHookProps {
  interval?: number | false
}

export const useTransactionChartHook = ({
  interval = false,
}: useTransactionChartHookProps) => {
  const [params, setParams] = useState<TransactionChartParams>({
    startDate: startOfDay(subDays(new Date(), 30)).toISOString(),
  })
  const { isError, isFetching, data, isLoading } = useQuery({
    queryKey: ['transactions', 'transactionChart', params],
    queryFn: async () => transactionsService.transactionChart(params),
    refetchInterval: interval,
    placeholderData: keepPreviousData,
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregador os dados, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    isFetching,
    data,
    setParams,
    isLoading,
  }
}
